import React, { useState } from 'react';

import {
  Grid,
  Typography,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';
import { BorderBottom } from '@mui/icons-material';
import { greyOutEmptyTextField } from '../../Helpers/helpers';

const InstallReportChekList = (props) => {
  const handleCheckList = props.handleCheckList;

  const [top_covers, set_top_covers] = useState(
    props.checkListData === undefined
      ? ''
      : props.checkListData.top_covers || ''
  );
  const [shelving, set_shelving] = useState(
    props.checkListData === undefined ? '' : props.checkListData.shelving || ''
  );
  const [glass_lids, set_glass_lids] = useState(
    props.checkListData === undefined
      ? ''
      : props.checkListData.glass_lids || ''
  );
  const [delivery_note, set_delivery_note] = useState(
    props.checkListData === undefined
      ? ''
      : props.checkListData.delivery_note || ''
  );
  const [grid_sets, set_grid_sets] = useState(
    props.checkListData === undefined ? '' : props.checkListData.grid_sets || ''
  );
  const [warrantee_form, set_warrantee_form] = useState(
    props.checkListData === undefined
      ? ''
      : props.checkListData.warrantee_form || ''
  );
  const [uprights_mounted, set_uprights_mounted] = useState(
    props.checkListData === undefined
      ? ''
      : props.checkListData.uprights_mounted || ''
  );
  const [sufficient_power, set_sufficient_power] = useState(
    props.checkListData === undefined
      ? ''
      : props.checkListData.sufficient_power || ''
  );
  const [cabinets_alligned, set_cabinets_alligned] = useState(
    props.checkListData === undefined
      ? ''
      : props.checkListData.cabinets_alligned || ''
  );

  const handleChange = (event) => {
    switch (event.target.name) {
      case 'top_covers':
        set_top_covers(event.target.value);
        break;

      case 'shelving':
        set_shelving(event.target.value);
        break;

      case 'glass_lids':
        set_glass_lids(event.target.value);
        break;

      case 'delivery_note':
        set_delivery_note(event.target.value);
        break;

      case 'grid_sets':
        set_grid_sets(event.target.value);
        break;

      case 'warrantee_form':
        set_warrantee_form(event.target.value);
        break;

      case 'uprights_mounted':
        set_uprights_mounted(event.target.value);
        break;

      case 'sufficient_power':
        set_sufficient_power(event.target.value);
        break;

      case 'cabinets_alligned':
        set_cabinets_alligned(event.target.value);
        break;

      default:
        break;
    }
    handleCheckList(event.target.name, event.target.value);
  };

  return (
    <>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
        borderTop='solid grey 1px'
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Top covers/glass fitted correctly:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left', background: greyOutEmptyTextField(top_covers) }}
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
        borderTop='solid grey 1px'
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='top_covers_label'
            id='top_covers'
            name='top_covers'
            value={top_covers}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
        borderLeft='solid grey 1px'
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
        borderTop='solid grey 1px'
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Shelving installed and stable:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left', background: greyOutEmptyTextField(shelving) }}
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
        borderTop='solid grey 1px'
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='shelving_label'
            id='shelving'
            name='shelving'
            value={shelving}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Glass lids free of debris and sliding smoothly:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left', background: greyOutEmptyTextField(glass_lids) }}
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='glass_lids_label'
            id='glass_lids'
            name='glass_lids'
            value={glass_lids}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
        borderLeft='solid grey 1px'
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Delivery Note checked and signed:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left', background: greyOutEmptyTextField(delivery_note) }}
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='delivery_note_label'
            id='glass_lids'
            name='delivery_note'
            value={delivery_note}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Grid sets inserted correctly:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left', background: greyOutEmptyTextField(grid_sets) }}
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='grid_sets_label'
            id='grid_sets'
            name='grid_sets'
            value={grid_sets}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
        borderLeft='solid grey 1px'
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Warrantee document signed:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left', background: greyOutEmptyTextField(warrantee_form) }}
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='warrantee_form_label'
            id='warrantee_form'
            name='warrantee_form'
            value={warrantee_form}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Units aligned and level:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left', background: greyOutEmptyTextField(uprights_mounted) }}
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='uprights_mounted_label'
            id='uprights_mounted'
            name='uprights_mounted'
            value={uprights_mounted}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
        borderLeft='solid grey 1px'
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Sufficient power supply:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left', background: greyOutEmptyTextField(sufficient_power) }}
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='sufficient_power_label'
            id='sufficient_power'
            name='sufficient_power'
            value={sufficient_power}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <Typography
          fontWeight='300'
          variant='subtitle1'
          paddingLeft={1}
          justifyContent='center'
        >
          Cleaning manuals supplied and explained:
        </Typography>
      </Grid>
      <Grid
        item
        md={3}
        xs={6}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left', background: greyOutEmptyTextField(cabinets_alligned) }}
        borderLeft='solid grey 1px'
        borderBottom='solid grey 1px'
      >
        <FormControl fullWidth>
          <Select
            className='input-print-style'
            size='small'
            labelId='cabinets_alligned_label'
            id='cabinets_alligned'
            name='cabinets_alligned'
            value={cabinets_alligned}
            onChange={handleChange}
          >
            <MenuItem value='Yes'>Yes</MenuItem>
            <MenuItem value='No'>No</MenuItem>
            <MenuItem value='N/A'>N/A</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid
        item
        //   border={'grey solid 1px'}
        // marginTop={1}
        md={6}
        xs={12}
        sx={{ display: 'flex', alignItems: 'center', textAlign: 'left' }}
        borderLeft='solid grey 1px'
        borderRight='solid grey 1px'
        borderBottom='solid grey 1px'
      ></Grid>
    </>
  );
};

export default InstallReportChekList;
